export default __webpack_public_path__ + "static/media/APACHE RTR 160 2V_2.732bfc9d.webp";